/* eslint-disable eslint-comments/no-restricted-disable, max-lines
-- It is better to keep everything in this file instead of splitting */
import { t } from "@/i18n-js/instance";

import type { TaxIdType } from "../TaxIdType";

export const getEurope = (): TaxIdType[] => {
  const commonDescription = t("tax_ids.europe_vat_description");

  return [
    {
      countryCode: "AT",
      country: t("tax_ids.austria"),
      label: t("tax_ids.austria_vat"),
      example: "ATU12345678",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(ATU|atu)\d{8}$/,
      },
    },
    {
      countryCode: "BE",
      country: t("tax_ids.belgium"),
      label: t("tax_ids.belgium_vat"),
      example: "BE0123456789",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(BE|be)\d{10}$/,
      },
    },
    {
      countryCode: "BG",
      country: t("tax_ids.bulgaria"),
      label: t("tax_ids.bulgaria_vat"),
      example: "BG0123456789",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(BG|bg)\d{9,10}$/,
      },
    },
    {
      countryCode: "BG",
      country: t("tax_ids.bulgaria"),
      label: t("tax_ids.bulgaria_uic"),
      example: "123456789",
      description: t("tax_ids.bulgaria_uic_description"),
      enum: "bg_uic",
    },
    {
      countryCode: "HR",
      country: t("tax_ids.croatia"),
      label: t("tax_ids.croatia_vat"),
      example: "HR12345678912",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(HR|hr)\d{11}$/,
      },
    },
    {
      countryCode: "CY",
      country: t("tax_ids.cyprus"),
      label: t("tax_ids.cyprus_vat"),
      example: "CY12345678Z",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(CY|cy)[a-zA-Z0-9]{9}$/,
      },
    },
    {
      countryCode: "CZ",
      country: t("tax_ids.czech_republic"),
      label: t("tax_ids.czech_republic_vat"),
      example: "CZ1234567890",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(CZ|cz)\d{8,10}$/,
      },
    },
    {
      countryCode: "DK",
      country: t("tax_ids.denmark"),
      label: t("tax_ids.denmark_vat"),
      example: "DK12345678",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(DK|dk)\d{8}$/,
      },
    },
    {
      countryCode: "EE",
      country: t("tax_ids.estonia"),
      label: t("tax_ids.estonia_vat"),
      example: "EE123456789",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(EE|ee)\d{9}$/,
      },
    },
    {
      countryCode: "FI",
      country: t("tax_ids.finland"),
      label: t("tax_ids.finland_vat"),
      example: "FI12345678",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(FI|fi)\d{8}$/,
      },
    },
    {
      countryCode: "FR",
      country: t("tax_ids.france"),
      label: t("tax_ids.france_vat"),
      example: "FRAB123456789",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(FR|fr)[a-zA-Z0-9]{11}$/,
      },
    },
    {
      countryCode: "DE",
      country: t("tax_ids.germany"),
      label: t("tax_ids.germany_vat"),
      example: "DE123456789",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(DE|de)\d{9}$/,
      },
    },
    {
      countryCode: "GB",
      country: t("tax_ids.united_kingdom"),
      label: t("tax_ids.united_kingdom_vat"),
      example: "GB123456789",
      description: t("tax_ids.united_kingdom_vat_description"),
      enum: "gb_vat",
      formOptions: {
        pattern: /(GB|gb)\d{9}$/,
      },
    },
    {
      countryCode: "GB",
      country: t("tax_ids.northern_ireland"),
      label: t("tax_ids.northern_ireland_vat"),
      example: "XI123456789",
      description: t("tax_ids.northern_ireland_vat_description"),
      enum: "eu_vat",
      formOptions: {
        pattern: /(XI|xi)\d{9}$/,
      },
    },
    {
      countryCode: "GR",
      country: t("tax_ids.greece"),
      label: t("tax_ids.greece_vat"),
      example: "EL123456789",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(EL|el)\d{9}$/,
      },
    },
    {
      countryCode: "HU",
      country: t("tax_ids.hungary"),
      label: t("tax_ids.hungary_vat"),
      example: "HU12345678912",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(HU|hu)\d{8,10}$/, // Some sources are defining with 9 digits, we will set from 8 to 10
      },
    },
    {
      countryCode: "HU",
      country: t("tax_ids.hungary"),
      label: t("tax_ids.hungary_tin"),
      example: "12345678-1-23",
      description: t("tax_ids.hungary_tin_description"),
      enum: "hu_tin",
    },
    {
      countryCode: "IE",
      country: t("tax_ids.ireland"),
      label: t("tax_ids.ireland_vat"),
      example: "IE1234567AB",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(IE|ie)[a-zA-Z0-9]{8,9}$/,
      },
    },
    {
      countryCode: "IT",
      country: t("tax_ids.italy"),
      label: t("tax_ids.italy_vat"),
      example: "IT12345678912",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(IT|it)\d{11}$/,
      },
    },
    {
      countryCode: "IT",
      country: t("tax_ids.italy"),
      label: t("tax_ids.italy_cf"),
      example: "ABCDEF12A12A123A",
      description: t("tax_ids.italy_cf_description"),
      enum: "it_cf",
      formOptions: {
        // cspell:ignore LMNPQRSTUV lmnpqrstuv
        pattern:
          /^[A-Za-z]{6}[0-9LMNPQRSTUVlmnpqrstuv]{2}[A-Za-z][0-9LMNPQRSTUVlmnpqrstuv]{2}[A-Za-z][0-9LMNPQRSTUVlmnpqrstuv]{3}[A-Za-z]$/,
      },
    },
    {
      countryCode: "LV",
      country: t("tax_ids.latvia"),
      label: t("tax_ids.latvia_vat"),
      example: "LV12345678912",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(LV|lv)\d{11}$/,
      },
    },
    {
      countryCode: "LT",
      country: t("tax_ids.lithuania"),
      label: t("tax_ids.lithuania_vat"),
      example: "LT123456789123",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(LT|lt)\d{9,12}$/,
      },
    },
    {
      countryCode: "LU",
      country: t("tax_ids.luxembourg"),
      label: t("tax_ids.luxembourg_vat"),
      example: "LU12345678",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(LU|lu)\d{8}$/,
      },
    },
    {
      countryCode: "MT",
      country: t("tax_ids.malta"),
      label: t("tax_ids.malta_vat"),
      example: "MT12345678",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(MT|mt)\d{8}$/,
      },
    },
    {
      countryCode: "NL",
      country: t("tax_ids.netherlands"),
      label: t("tax_ids.netherlands_vat"),
      example: "NL123456789B12",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(NL|nl)[a-zA-Z0-9]{12}$/,
      },
    },
    {
      countryCode: "PL",
      country: t("tax_ids.poland"),
      label: t("tax_ids.poland_vat"),
      example: "PL1234567890",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(PL|pl)\d{10}$/,
      },
    },
    {
      countryCode: "PT",
      country: t("tax_ids.portugal"),
      label: t("tax_ids.portugal_vat"),
      example: "PT123456789",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(PT|pt)\d{9}$/,
      },
    },
    {
      countryCode: "RO",
      country: t("tax_ids.romania"),
      label: t("tax_ids.romania_vat"),
      example: "RO1234567891",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(RO|ro)\d{2,10}$/,
      },
    },
    {
      countryCode: "SK",
      country: t("tax_ids.slovakia"),
      label: t("tax_ids.slovakia_vat"),
      example: "SK1234567891",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(SK|sk)\d{10}$/,
      },
    },
    {
      countryCode: "SI",
      country: t("tax_ids.slovenia"),
      label: t("tax_ids.slovenia_vat"),
      example: "SI12345678",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(SI|si)\d{8}$/,
      },
    },
    {
      countryCode: "ES",
      country: t("tax_ids.spain"),
      label: t("tax_ids.spain_vat"),
      example: "ESA1234567Z",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(ES|es)[a-zA-Z0-9]{9}$/,
      },
    },
    {
      countryCode: "ES",
      country: t("tax_ids.spain"),
      label: t("tax_ids.spain_cif"),
      example: "A12345678",
      description: t("tax_ids.spain_cif_description"),
      enum: "es_cif",
    },
    {
      countryCode: "SE",
      country: t("tax_ids.sweden"),
      label: t("tax_ids.sweden_vat"),
      example: "SE123456789123",
      description: commonDescription,
      enum: "eu_vat",
      formOptions: {
        pattern: /(SE|se)\d{12}$/,
      },
    },
    {
      countryCode: "CH",
      country: t("tax_ids.switzerland"),
      label: t("tax_ids.switzerland_vat"),
      example: "CHE-123.456.789 MWST",
      description: t("tax_ids.switzerland_vat_description"),
      enum: "ch_vat",
      formOptions: {
        pattern: /CHE-\d{3}.\d{3}.\d{3} ?[a-zA-Z]{2,4}$/,
      },
    },
    {
      countryCode: "NO",
      country: t("tax_ids.norway"),
      label: t("tax_ids.norway_vat"),
      example: "123456789MVA",
      description: t("tax_ids.norway_vat_description"),
      enum: "no_vat",
      formOptions: {
        pattern: /\d{9}(MVA| MVA|mva| mva)$/,
      },
    },
    {
      countryCode: "IS",
      country: t("tax_ids.iceland"),
      label: t("tax_ids.iceland_vat"),
      example: "123456",
      description: t("tax_ids.iceland_vat_description"),
      enum: "is_vat",
      formOptions: {
        pattern: /\d{5,6}$/,
      },
    },
    {
      countryCode: "EU",
      country: t("tax_ids.european_union"),
      label: t("tax_ids.european_union_oss_vat"),
      example: "EU123456789",
      description: t("tax_ids.european_union_oss_vat_description"),
      enum: "eu_oss_vat",
    },
  ];
};
